class ProductFilters extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.filterData = [];
    this.searchParamsInitial = window.location.search.slice(1);
    this.searchParamsPrev = window.location.search.slice(1);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    window.addEventListener('popstate', (event) => {
      const searchParams = event.state ? event.state.searchParams : this.searchParamsInitial;
      if (searchParams === this.searchParamsPrev) return;

      this.renderPage(searchParams, null, false);
    });
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.querySelectorAll('.filter-sort-form').forEach((form) => {
      form.addEventListener('change', this.debouncedOnSubmit.bind(this));
    });

    const select = this.querySelector('.dynamicSelect');
    adjustSelectWidth(select);

    select.addEventListener('change', function() {
        adjustSelectWidth(select);
    });

    this.querySelectorAll('facet-remove').forEach((element) => {
      element.addEventListener('click', (event) => {
        this.onActiveFilterClick(event);
      });
    });
    const breadcrumbsProductCount = document.querySelector('.collection-count__value');
    if (breadcrumbsProductCount) {
      breadcrumbsProductCount.innerHTML = this.querySelector('#ProductCountDesktop').dataset.count;
    }

    // document.querySelector('.collection-count__value').innerHTML = this.querySelector('#ProductCountDesktop').dataset.count;
  }

  renderPage(searchParams, event, updateURLHash = true) {
    this.searchParamsPrev = searchParams;

    const url = `${window.location.pathname}?section_id=${this.dataset.section}&${searchParams}`;

    //   this.filterData.some(el => el.url === url)
    //     ? this.renderSectionFromCache(filterDataUrl, event)
    //     : this.renderSectionFromFetch(url, event);
    
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const htmlString = responseText;

        this.filterData = [...this.filterData, { htmlString, url }];
        // this.renderFilters(html, event);
        // this.renderProductGridContainer(html);
        // this.renderProductCount(html);

        const html = new DOMParser().parseFromString(htmlString, 'text/html').getElementById('collection-page-container');

        if(!html) return;

        const openDetailsIds = [...this.querySelectorAll('details[open]')].map((element) => element.id);
        const sidebarScrollTop = this.querySelector('.grid__item--sidebar').scrollTop;
        const sidebarOpened = this.querySelector('#main-collection-filters').classList.contains('active');

        openDetailsIds.forEach((selector) => {
          const detailsElement = html.querySelector(`#${selector}`);

          detailsElement && detailsElement.setAttribute('open', '');
        });

        sidebarOpened && html.querySelector('#main-collection-filters').classList.add('active');

        
        document.querySelector('#collection-page-container').innerHTML = html.innerHTML;

        if(document.querySelector('.grid__item--sidebar')) {
          document.querySelector('.grid__item--sidebar').scrollTop = sidebarScrollTop;
        }

        this.init();


        if (updateURLHash) {
          history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
        }
      });
  }

  // renderSectionFromCache(filterDataUrl, event) {
  //   const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
  //   FacetFiltersForm.renderFilters(html, event);
  //   FacetFiltersForm.renderProductGridContainer(html);
  //   FacetFiltersForm.renderProductCount(html);
  // }

  onSubmitHandler(event) {
    event.preventDefault();

    const forms = [];
      
    this.querySelectorAll('.filter-sort-form').forEach((form) => {
      forms.push(new URLSearchParams(new FormData(form)).toString());
    });

    this.renderPage(forms.join('&'), event);
  }

  onActiveFilterClick(event) {
    const href = event.currentTarget.dataset.href;

    const url = href.indexOf('?') == -1 ? '' : href.slice(href.indexOf('?') + 1);

    this.renderPage(url);
  }
}

customElements.define('product-filters', ProductFilters);




class FilterMobtrigger extends HTMLElement {
  constructor() {
    super();

    this.onFilterMobtriggerClick = this.onFilterMobtriggerClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.onFilterMobtriggerClick.bind(this));
  }

  onFilterMobtriggerClick(event) {
    document.querySelector('#main-collection-filters').classList.add('active');
  }
}
customElements.define('filter-mobtrigger', FilterMobtrigger);


class PriceRangeSelector extends HTMLElement {
  constructor() {
    super();

    this.range_inputs = document.querySelectorAll(".range-input");
    this.price_inputs = document.querySelectorAll(".price-input");
    this.range = document.querySelector(".slider .progress");

    this.min = 0;
    this.max = this.price_inputs[1].max;
    this.price_gap = Math.round(this.max / 20);

    this.onRangeInput = this.onRangeInput.bind(this);

    this.range_inputs.forEach((element) =>
      element.addEventListener('input', this.onRangeInput.bind(this))
    );


    this.onPriceInput = this.onPriceInput.bind(this);

    // this.debouncedOnInput = debounce((event) => {
    //   this.onPriceInput(event);
    // }, 3000);

    this.price_inputs.forEach((element) => {
      // element.addEventListener('input', this.debouncedOnInput.bind(this))
      element.addEventListener('change', this.onPriceInput.bind(this))
    });
  }

  connectedCallback() {
    this.range.style.left = (this.price_inputs[0].value / this.max) * 100 + "%";
    this.range.style.right = 100 - (this.price_inputs[1].value / this.max) * 100 + "%";
  }

  onRangeInput(e) {
    let min_val = Math.round(this.range_inputs[0].value),
        max_val = Math.round(this.range_inputs[1].value);

    if (max_val - min_val < this.price_gap) {
      if (e.target.classList.contains("range-min")) {
        this.range_inputs[0].value = max_val - this.price_gap;
      } else if (e.target.classList.contains("range-max")) {
        this.range_inputs[1].value = min_val + this.price_gap;
      }
    } else {
      this.price_inputs[0].value = min_val;
      this.price_inputs[1].value = max_val;

      this.range.style.left = (min_val / this.range_inputs[0].max) * 100 + "%";
      this.range.style.right = 100 - (max_val / this.range_inputs[1].max) * 100 + "%";
    }
  }

  onPriceInput(e) {
    let min_price = parseInt(this.price_inputs[0].value),
        max_price = parseInt(this.price_inputs[1].value);

    if (e.target.classList.contains("input-min")) {
      if (min_price < this.min) {
        this.price_inputs[0].value = this.min;
      } else if (max_price - min_price < this.price_gap) {
        this.price_inputs[0].value = max_price - this.price_gap;
      } else {
        this.range_inputs[0].value = min_price;
        this.range.style.left = (min_price / this.range_inputs[0].max) * 100 + "%";
      }
    }

    if (e.target.classList.contains("input-max")) {
      if (max_price > this.max) {
        this.price_inputs[1].value = this.max;
      } else if (max_price - min_price < this.price_gap) {
        this.price_inputs[1].value = min_price + this.price_gap;
      } else {
        this.range_inputs[1].value = max_price;
        this.range.style.right = 100 - (max_price / this.range_inputs[1].max) * 100 + "%";
      }
    }
  }
}

customElements.define('price-range-selector', PriceRangeSelector);




function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function adjustSelectWidth(selectElement) {
  var tempSpan = document.createElement('span');
  
  tempSpan.innerHTML = selectElement.options[selectElement.selectedIndex].text;
  tempSpan.style.visibility = 'hidden';
  selectElement.after(tempSpan);
  selectElement.style.width = tempSpan.offsetWidth + 22 + 'px';
  selectElement.parentElement.removeChild(tempSpan);
}